/**
 * Created by dongjf on 2019/5/28
 */
// import React from 'react';
import { connect } from '@souche-f2e/muji';
const mapStateToProps = (rootState) => {
    return { resources: rootState.global.resources };
};
// 可以传各种 props 设定行为，比如返回空还是 clone 传属性
const AuthorizedOr = ({ resources, allow, children }) => {
    const realAllow = allow.filter((v) => (resources.includes(v)));
    if (realAllow.length > 0) {
        return children;
    }
    return null;
};
export default connect(mapStateToProps)(AuthorizedOr);
